export interface ActionItem {
  id: string;
  type: 'email';
  title: string;
  description: string;
  founderName: string;
  founderEmail: string;
  founderId: string;
  priority: 'high' | 'medium' | 'low';
  dueDate?: string;
  dueTime?: string;
  timezone?: string;
  reminderOffsetMinutes?: number;
  status: 'todo' | 'done';
  recurrence?: string | null;
  nextDueDate?: string | null;
  createdAt: string;
  Founder?: {
    name: string;
  };
}

export interface ActionItemsProps {
  onFounderClick?: (founderId: string) => void;
  onViewModeChange?: (viewMode: 'calendar' | 'board') => void;
  initialViewMode?: 'calendar' | 'board';
}

export interface EditValues {
  title: string;
  description: string;
  dueDate: string;
  dueTime: string;
  recurrence: string;
  reminderOffsetMinutes: string;
}

export interface NewCardValues extends EditValues {
  status: string;
}

export interface CalendarTask {
  id: string;
  title: string;
  description: string;
  status: string;
  dueDate?: string;
  recurrence?: string | null;
  nextDueDate?: string | null;
  founderId: string;
  Founder?: {
    name: string;
  };
}

export type TaskStatus = 'pending' | 'completed';
export type ApiStatus = 'todo' | 'done';

export const STATUS_MAP: Record<TaskStatus, ApiStatus> = {
  pending: 'todo',
  completed: 'done',
};
